import { getIssueTicketingSystems } from "@/domain/ticketing"
import { useTicketing } from "./useTicketing"

import type { RepositoryResource } from "@/domain/ticketing"

// Without any connected system the button stays, pointing to the integrations;
// it is hidden only when every connected system is ruled out for the issue
export const useIssueTicketingSystems = (resources?: RepositoryResource[]) => {
  const { systems: connected, issuesDisabledOwners } = useTicketing()
  const systems = getIssueTicketingSystems(
    connected,
    resources,
    issuesDisabledOwners
  )

  return {
    systems,
    hasIntegration: systems.length > 0,
    isHidden: connected.length > 0 && !systems.length
  }
}
